import {create} from "zustand";

import {Company} from "../types";

type CompanyStoreState = {
  company: Company | null;
};

type CompanyStoreActions = {
  setCompany: (company: Company | null) => void;
  clear: () => void;
};

export const useCompanyStore = create<CompanyStoreState & CompanyStoreActions>((set) => ({
  company: null,

  setCompany: (company: Company | null) => set({company}),
  clear: () => set({company: null}),
}));

export function useStoredCompany() {
  return useCompanyStore((state) => state.company);
}

export function useSetCompany() {
  return useCompanyStore((state) => state.setCompany);
}

export function useClearCompany() {
  return useCompanyStore((state) => state.clear);
}

